import "../../assets/css/landing.css";
import "../../assets/css/home.css";

import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import side_banner5 from "../../assets/images/homepage/side_banner_4.png";
import { useEffect, useState } from "react";
import { Col, Row } from "antd";
import { Modal } from "antd";
import topHeader1 from "../../assets/images/homepage/topHeader1.png";
import appImg from "../../assets/images/homepage/appImg.png";
import chef from "../../assets/images/homepage/chef.png";
import bannerMeal from "../../assets/images/homepage/bannerMeal.png";
import SearchRestaurant from "../../components/SearchRestaurant";
import DealsCard from "../../components/DealsCard";
import MobileDownloadStores from "../../components/MobileDownloadStores";
import { _get_profile} from '../../common/axios_services';
import { useNavigate } from "react-router-dom";
import { PinActivation } from "../../components/PinActivation";
import { useSelector, useDispatch } from 'react-redux';
import { logoutUser } from '../../slices/authSlice';

const HomePage = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [partnerModalOpen, setPartnerModalOpen] = useState(false);
  const [vendorPartnerModalOpen, setVendorPartnerModalOpen] = useState(false);
  const [appModalOpen, setAppModalOpen] = useState(false);
  const [isVendor, setIsVendor] = useState(false)
  const [isVendorActive, setIsVendorActive] = useState(false)
  const [isRestaurant, setIsRestaurant] = useState(false)
  const [userSignedIn, setUserSignedIn] = useState(false)
  const [userloginPinSet, setUserLoginPinSet] = useState(false)
  const [accountId, setAccountId] = useState("")
  const [showRestaurantModal, setShowRestaurantModal] = useState(false);
  const userData = useSelector(state => state.userProfile.dataFetched);

  const getUserProfile = async () => {
    try{
      let result = await _get_profile(); 
      console.log({ user : result })
      setIsVendor(result?.data?.data.is_so);
      setIsVendorActive(result?.data?.data.is_vendor);
      setIsRestaurant(result?.data?.data.is_restaurant);
      setAccountId(result?.data?.data.account_id);
      // ACTIVATE PIN
      setUserLoginPinSet(result?.data?.data.login_pin_set);
      setUserSignedIn(true);
    }
    catch(e){
      if (e.response) {
        if (e.response.data.message === "Unauthorized") {
         setUserSignedIn(false)
          localStorage.removeItem('konnect_token')
        } 
    }
    }
  }

  // JOIN NOW MODAL
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };


 /* EXPERIENCE APP MODAL */
  const showAppModal = () => {
    setAppModalOpen(true); 
  };
  const handleAppCancel = () => {
    setAppModalOpen(false);
  };

  /* PARTNERSHIP MODAL */
  const showPartnerModal = () => {
    if (userSignedIn && !isVendor) {
      setShowRestaurantModal(true); 
    } else if((isVendor && !isRestaurant) || !userSignedIn) {
      navigate('/restaurant/dashboard');
      // setVendorPartnerModalOpen(true); 
    } else if (isVendor && isRestaurant) {
      navigate('/restaurant/dashboard')
    }
  };

  // is not vendor
  const handlePartnerCancel = () => {
    setShowRestaurantModal(false);
  };

  /* Is vendor but not restaurant*/
  const handleVendorPartnerCancel = () => {
    setVendorPartnerModalOpen(false);
  };

  useEffect(() => {
    getUserProfile()
  }, []);

  useEffect(() => {
    // Check if the URL contains the #partnerWithUs hash
    if (window.location.hash === "#partnerWithUs") {
      const element = document.getElementById("partnerWithUs");
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, []); // Empty dependency array ensures this runs once on component mount

  const handleRestaurantClick = () => {
    if (!userSignedIn) {
      showPartnerModal(); // Show modal for non-logged-in users
    } else if (userData?.is_vendor || userData?.is_restaurant) {
      navigate('/restaurant/dashboard'); // Direct navigate for vendors/restaurants
    } else {
      showPartnerModal(); // Show modal for logged-in non-vendors
    }
  };

  return (
    <div>
      {
        (userSignedIn && !userloginPinSet)
         && (
            <PinActivation 
            open={!userloginPinSet} 
            toClose={setUserLoginPinSet} 
            accountId={accountId}
          />
        )
        }
      <Navbar noShadow={true} adjustNavSize={true}  />
      {/* Hero Section */}
      <div>
        <Row
        align={"middle"}
        justify={"center"}
        className="h-screen min-h-screen max-h-screen w-full px-12 "
        gutter={{ sm: 4, md: 24, lg: 48 }}
        >
          <Col xs={24} md={12}>
            <div className="">
              <img className="bg-[#f5f5f5] w-full" src={topHeader1} alt="hero_image" />
            </div>
          </Col>
          <Col xs={24} md={12}>
              <div className=" max-md:text-center max-[767px]:mt-20  text_h3 gap-y-2 flex flex-col">
                  <p className="lg:text-8xl xl:text-9xl text-6xl text_h3">
                      Hungry?
                  </p>
                  <p className="lg:text-8xl xl:text-9xl text-6xl text_h3">
                      No stress,
                  </p>
                  <p className="lg:text-8xl xl:text-9xl text-6xl text_h3">
                    <span className="text-[#44843F] font-bold">we go run am sharp sharp!</span>
                  </p>
              </div>
              <div className="lg:mt-44 max-md:my-20 " >
                  <SearchRestaurant />
              </div>
          </Col>
        </Row>
      </div>

      {/* Second Section */}
      <div id="partnerWithUs" >
        <Row
          align={"middle"}
          justify={"center"}
          className="h-auto w-full px-12 my-36 "
        >
          <Col xs={24} md={12}>
            <div className="text_h3 gap-y-2 w-full max-sm:mt-7 flex justify-center flex-col">
              <p className="lg:text-8xl xl:text-9xl text-6xl text_h3">
                You Cook...
              </p>
              <p className="lg:text-8xl xl:text-9xl text-6xl text_h3">
                We Sell & Grow
              </p>
              <p className="lg:text-8xl xl:text-9xl text-6xl text_h3">
                Your Business
              </p>
            </div>
            <div className="w-full flex justify-center items-center max-md:mt-5 mt-3  max-md:justify-center">
                <button
                    onClick={handleRestaurantClick}
                    className="flex justify-end rounded-button focus:outline-none "
                >
                  {/* {!userSignedIn ? "Become a restaurant" : 
                    userData?.is_restaurant ? "My restaurant dashboard" : 
                    userData?.is_vendor && !userData?.is_restaurant? "Activate my restaurant" : 
                    "Become a restaurant"} */}
                    {!userSignedIn ? "Become a restaurant" : 
                    userData?.is_restaurant ? "My restaurant dashboard" : 
                    userData?.is_vendor && !userData?.is_restaurant? "Activate my restaurant" : 
                    "Activate my restaurant"}
                </button>
            </div>
          </Col>
          <Col xs={24} md={12}>
            <div className="">
              <img src={chef} alt="chef_image" />
            </div>
          </Col>
        </Row>
        {/*  */}
       </div>

      {/* Third Section */}
      <div className="h-auto max-[767px]:mt-52  ">
        <Row
          align={"middle"}
          justify={"center"}
          className="h-auto w-full px-12 my-36"
        >

          <Col xs={24} md={12}>
            <div className="w-full flex justify-center">
              <img src={appImg} alt="_image" />
            </div>
          </Col>
          <Col xs={24} md={12}>
              <div className=" max-md:text-center text_h3 gap-y-2 flex flex-col">
                <p className="lg:text-8xl xl:text-9xl text-6xl text_h3">
                    Get Cash
                </p>
                <p className="lg:text-8xl xl:text-9xl text-6xl text_h3">
                    Weekly Via
                </p>
                <p className="lg:text-8xl xl:text-9xl text-6xl text_h3">
                    Our App
                </p>
              </div>
              <MobileDownloadStores />
          </Col>
        </Row>
      </div>
       

      {/* Fourth Section  */}
      {/* <DealsCard /> */}


      {/* Fifth Section */}
      <div>
        <Row
          align={"middle"}
          justify={"center"}
          className="h-auto w-full px-12 my-36"
        >
          <Col xs={24} md={12}>
              <div className=" text_h3 gap-y-2 flex flex-col">
              <p className="lg:text-8xl xl:text-9xl capitalize text-6xl text_h3">
                  Join us today
                  {/*<span className="text-[#44843F] font-bold"> Konnect</span> */}
              </p>
              <p className="lg:text-8xl xl:text-9xl capitalize text-6xl text_h3">
                  & earn daily
              </p>

              </div>
              <div className="flex items-center gap-3 max-md:mt-5 mt-3  mb-3 max-md:justify-center">
                {
                  !userSignedIn ? (  
                  <a 
                    href="/signin" 
                    className="rounded-button"
                  >Join Now</a>
                  ) : 
                  (
                    <button onClick={showModal} className="rounded-button focus:outline-none ">
                      Join Now
                    </button>
                  )
                }
              </div>
          </Col>
          <Col xs={24} md={12}>
              <div className="w-full flex justify-center">
              <img src={side_banner5} alt="_image" />
              </div>
          </Col>
        </Row>
      </div>


      {/* Sixth Section */}
      <div>
        <Row
          align={"middle"}
          justify={"center"}
          className="h-auto w-full px-12 my-36 "
        >
          <Col xs={24} md={12}>
            <div className=" text_h3 gap-y-2 flex flex-col">
              <p className="lg:text-8xl xl:text-9xl text-6xl text_h3">
                  Think Breakfast
              </p>
              <p className="lg:text-8xl xl:text-9xl text-6xl text_h3">
                  Lunch & Dinner
              </p>
              <p className="lg:text-8xl xl:text-9xl text-6xl text_h3">
                  Think <span className="text-[#44843F] font-bold"> Konnect</span>
              </p>
            </div>
          </Col>
          <Col xs={24} md={12}>
            <div className="w-full flex justify-center">
              <img src={bannerMeal} alt="_image" />
            </div>
          </Col>

        </Row>
      </div>

      {/* FOOTER */}
      <Footer />

      {/* MODALS */}

      {/* JOIN MARKETING TEAM MODAL */}
      <Modal
        open={isModalOpen}
        footer={false}
        onCancel={handleCancel}
        className="partnerModal"
      >
        <h2 className="text-green-800 font-bold flex items-center my-4 mt-8 text-5xl" >Refer & earn cash daily</h2>
        <div>
          <ul class="numbered-list">
            <li className="marker:text-[#44843F]">Download the app <span className={'font-bold'}>(click below)</span> </li>
            <li className="marker:text-[#44843F]">Login and visit account page</li>
            <li className="marker:text-[#44843F]">Click view referral code</li>
            <li className="marker:text-[#44843F]">Share your referral code or link with people</li>
          </ul>
          <p className={'font-bold my-3'} >We credit your wallet daily with instant cash</p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              marginTop: "10px",
            }}
          >
            <MobileDownloadStores />

          </div>
        </div>
      </Modal>

      {/* IS VENDOR PARTNERSHIP MODAL */}
      <Modal
        open={vendorPartnerModalOpen }
        footer={false}
        onCancel={handleVendorPartnerCancel}
        className="partnerModal"
      >
        <h2 className="text-green-800 font-bold flex items-center my-4 mt-8 text-5xl ">
          Become a Restaurant & Earn More
        </h2>
        <ul className="list-disc pl-5 space-y-2 mt-2">
          <li className="marker:text-[#44843F]">Only a <span className="font-bold" >Food Vendor</span> can become a restaurant </li>
          <li className="marker:text-[#44843F]">Reach more customers than ever (onsite and online)</li>
          <li className="marker:text-[#44843F]">We sell, deliver, and help you grow your business.</li>
          <li className="marker:text-[#44843F]">Restaurants can earn more than a million Naira weekly.</li>
        </ul>
        <p className="mt-4">
          Interested? <a href={ !userSignedIn ? "signup": "/restaurant/dashboard"} className="text-green-800 font-bold underline hover:text-green-900">CLICK HERE</a> and follow the process.
        </p>
      </Modal>

      {/* IS NOT VENDOR PARTNERSHIP MODAL */}
      <Modal
        open={partnerModalOpen }
        footer={false}
        onCancel={handlePartnerCancel}
        className="partnerModal"
      >
        <h2 className="text-green-800 font-bold flex items-center my-4 mt-8 text-5xl ">
          Welcome to Konnect Food
        </h2>
        <ul className="list-disc pl-5 space-y-2 mt-2">
        <li className="marker:text-[red]">Note, only Food vendors can apply to become a restaurant. </li>
        <li className="marker:text-[#44843F]">Interested? Create a food vendor account and follow the steps.</li>
        </ul>
        <button onClick={() => navigate('/signup')} className="rounded-button flex mx-auto my-3 focus:outline-none ">
          Sign Up Today!
       </button>
      </Modal>

      {/* EXPERIENCE APP MODAL */}
      <Modal
        open={appModalOpen}
        footer={false}
        onCancel={handleAppCancel}
        className="appModal"
      >
        <h2 className="text-[#3b823a] text-5xl my-4" >Eat Cheaper on Konnect </h2>
          <div>
              <p>
                  <span role="img" aria-label="gift">🎁</span> Sign-up TODAY & get <span
                  className="font-bold">10%</span>discount <i>(7 days validity)</i>
              </p>
              <p>
                  <span role="img" aria-label="cart">🛒</span>Up to 10% extra discount on 1st 3 orders
              </p>
              <p>
                  <span role="img" aria-label="thumbs-up">⭐</span>Up to 30% discount on 4th order
              </p>
              <p>
                  <span role="img" aria-label="thumbs-up">✨</span>Discounts for 1st to 4th orders are repeated
              </p>

          </div>
          <div
              style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginTop: "10px",
              }}
          >
          <MobileDownloadStores  />
        </div>
      </Modal>

      {/* Logged in User and not vendor or restaurant yet */}
      <Modal
        title="Account Type Change Required"
        open={showRestaurantModal}
        onCancel={() => setShowRestaurantModal(false)}
        footer={[
          <button 
            key="cancel" 
            className="px-4 py-2 mr-2 text-gray-600 hover:text-gray-800 transition-colors"
            onClick={() => setShowRestaurantModal(false)}
          >
            Okay
          </button>,
          <button 
            key="logout"
            className="bg-[#063F29] text-white px-4 py-2 rounded hover:bg-[#052a1d] transition-colors"
            onClick={() => {
              dispatch(logoutUser());
              navigate('/signup');
              setShowRestaurantModal(false);
            }}
          >
            Logout & Register
          </button>
        ]}
        className="custom-bottom-sheet"
      >
        <div className="space-y-4">
          <div className="bg-yellow-50 p-3 rounded-md border border-yellow-200">
            <p className="font-semibold text-yellow-800 flex items-center gap-2">
              <span>⚠️</span>
              Note: To become a Restaurant, you must sign-out and create a new business account 
              plus WhatsApp link.
            </p>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default HomePage;
